import { atom } from 'recoil';

export const isProjectFlatAtom = atom({
  key: 'isProjectFlatAtom',
  default: false,
});
